import axios, { AxiosResponse } from 'axios';
import { SC5Report, SC5Status } from '../../types/SC5Report';
import { CustRReport, CustRReportResponse } from '../../types/CustRReport';
import { BGEReport } from '../../types/BGEReport';

const currentStateUrl = `https://kubra.io/stormcenter/api/v1/stormcenters/${process.env.REACT_APP_SC5_INSTANCE}/views/${process.env.REACT_APP_INSTANCE_VIEW_ID}/currentState`;
const dataBaseUrl = 'https://kubra.io';
const custRestoredUrl = `${process.env.REACT_APP_CUST_R_ENDPOINT}`;


export const getDataDirectory = (): Promise<SC5Status> => (
  axios.get(currentStateUrl)).then((res: AxiosResponse): SC5Status => res.data);

const getCustRestored = (): Promise<CustRReport> => (
  axios.get(custRestoredUrl).then((response: AxiosResponse): CustRReportResponse => (response.data as CustRReportResponse))
    .then((reportResponse: CustRReportResponse): CustRReport => {
      const report: CustRReport = {
        stormMode: reportResponse.stormmode === 'Y',
        counties: {},
        totalCustR: 0,
      };
      if (!reportResponse) {
        return {
          stormMode: false,
          counties: {
          },
          totalCustR: 0,
        };
      }
      reportResponse.counties.forEach((county: { county: string; customersRestored: number }): void => {
        report.counties[county.county] = county.customersRestored;
        report.totalCustR += county.customersRestored;
      });
      return report;
    })
);

const getReport = async (): Promise<BGEReport> => {
  const [currentState, custRReport]: [SC5Status, CustRReport] = await Promise.all([getDataDirectory(), getCustRestored()]);
  const { interval_generation_data: dataDirectory } = currentState.data;
  const { updatedAt } = currentState;
  return axios.get(`${dataBaseUrl}/${dataDirectory}/public/${process.env.REACT_APP_REPORT_PATH}`)
    .then((response: AxiosResponse): SC5Report => (response.data as SC5Report))
    .then((report: SC5Report): SC5Report => ({ ...report, updatedAt }))
    .then((report: SC5Report): BGEReport => ({
      sc5Report: report,
      custRestored: custRReport,
    }));
};

export default {
  getReport,
  getCustRestored,
};
